module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.primaryAttorney != false) ? _c('div', {
    staticClass: "panel panel-primary",
    attrs: {
      "id": "primary-attorney-display"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Primary Attorney")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "fullname"
  }, [_vm._v(_vm._s(_vm.primaryAttorney.user.firstName) + _vm._s(_vm.primaryAttorney.user.lastName))]), _vm._v(" "), _c('div', {
    staticClass: "contact-block"
  }, [_c('p', [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('a', {
    staticClass: "email-link",
    attrs: {
      "href": 'mailto:' + _vm.primaryAttorney.user.email
    }
  }, [_vm._v(_vm._s(_vm.primaryAttorney.user.email))])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13fc035b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrimaryAttorneyDisplay.vue
// module id = 273
// module chunks = 1